const emptyArray = [];

export const parseQueryArray = (maybeArray = emptyArray) =>
  (Array.isArray(maybeArray) ? maybeArray : [maybeArray]);
